import { getToken, getToken2, getUser } from "../../Utils/Common";
import { getAPICall, postAPICall } from "../axiosMethodCalls";
import Moment from "moment";
//GET ALL
export const getAllAdjustments = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "adjustments/get_all_adjustment",
            {
                requester: getUser(),
                token: getToken(),
                // branch_id: id
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};
export const searchAdjustments = async (filterConfig) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "adjustments/search",
            {
                requester: getUser(),
                token: getToken(),
                status: filterConfig.status !== "system_adjustments" ? filterConfig.status : "",
                branch_id: filterConfig.branch_id,
                // counted_by: filterConfig.counted_by,
                anything: filterConfig.anything,
                remarks: filterConfig.remarks,
                item_id: filterConfig.item_id,
                item_type: filterConfig.item_type,
                type_id: filterConfig.type_id,
                date_from: filterConfig.date_from ? Moment(filterConfig.date_from).format("YYYY-MM-DD") : filterConfig.date_from,
                date_to: filterConfig.date_to ? Moment(filterConfig.date_to).format("YYYY-MM-DD") : filterConfig.date_to,
                name: filterConfig.name,
                request_type: filterConfig.type,
                category_name: filterConfig.category,
                subcategory_name: filterConfig.subcategory,
                page: filterConfig.page,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const searchStoreAdjustments = async (filterConfig) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "adjustments/search",
            {
                requester: getUser(),
                token: getToken(),
                status: filterConfig.status,
                branch_id: filterConfig.branch_id,
                // counted_by: filterConfig.counted_by,
                remarks: filterConfig.remarks,
                item_id: filterConfig.item_id,
                type_id: filterConfig.type_id,
                approved_by: filterConfig.approved_by,
                remarks: filterConfig.remarks,
                added_on_from: filterConfig.date_from ? Moment(filterConfig.date_from).format("YYYY-MM-DD") : "",
                added_on_to: filterConfig.date_to ? Moment(filterConfig.date_to).format("YYYY-MM-DD") : "",
                name: filterConfig.name,
                request_type: filterConfig.type,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const getAdjustment = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "adjustments/get_adjustment",
            {
                requester: getUser(),
                token: getToken(),
                adjustment_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const getAllAdjustmentItemType = async (source) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "adjustments/get_all_adjustment_types",
            {
                requester: getUser(),
                token: getToken(),
                source: source,
                // branch_id: id
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};


export const getAllAdjustmentItemTypePotato = async (source) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "adjustments/get_all_adjustment_types",
            {
                requester: getUser(),
                token: getToken2(),
                source: source,
                // branch_id: id
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

//FILTER
export const searchByDate = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "adjustments/search",
            {
                requester: getUser(),
                token: getToken(),
                added_on_from: data.to
                    ? Moment(data.from).format("YYYY-MM-DD")
                    : data.to,
                added_on_to: data.to
                    ? Moment(data.to).format("YYYY-MM-DD")
                    : data.to,
                branch_id: data.branch_id,
                item_id: data.item_id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const searchByCounter = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "adjustments/search",
            {
                requester: getUser(),
                token: getToken(),
                counted_by: data,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

// CREATE ADJUSTMENT
export const createAdjustment = async (adjustment) => {

    try {
        const formData = new FormData();
        adjustment.attachments.map((file) => {
            formData.append(`attachments[]`, file, file.name);
        })
        formData.append('requester', getUser());
        formData.append('token', getToken());
        formData.append('inventory_id', adjustment.inventory_id);
        formData.append('item_id', adjustment.item_id);
        formData.append('branch_id', adjustment.branch_id);
        formData.append('type_id', adjustment.type_id);
        formData.append('counted_by', adjustment.counted_by);
        formData.append('physical_count', adjustment.physical_count);
        formData.append('difference', adjustment.difference);
        formData.append('unit', adjustment.unit);
        formData.append('remarks', adjustment.remarks ? adjustment.remarks : "");
        formData.append('qty_on_receipt', adjustment.qty_on_receipt ? adjustment.qty_on_receipt : "");
        formData.append('date_delivered', adjustment.date_delivered ? adjustment.date_delivered : "");
        formData.append('date_counted', adjustment.date_counted ? adjustment.date_counted : "");
        formData.append('request_type', adjustment.request_type);

        const response = await postAPICall(
            process.env.REACT_APP_LINK + "adjustments/create",
            formData,
            true
        );

        return { data: response.data };
    } catch (error) {
        return { error: error };
    }

};

export const updateAdjustmentStatus = async (data, remarks, status, request_type) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "adjustments/update_status",
            {
                requester: getUser(),
                token: getToken(),
                status: status,
                request_type: request_type,
                remarks: remarks, // admin remarks when approving adjustment requests

                adjustment_ids: data.map((adjustment) => {
                    return adjustment.id;
                }),
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};
